// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 便签节点样式
 */

.NoteNode-container {
  position: relative;
  min-width: 280px;
  max-width: 400px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  transition: box-shadow 0.2s ease;
}

.NoteNode-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.NoteNode-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
}

.NoteNode-icon {
  font-size: 16px;
}

.NoteNode-title {
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.NoteNode-color-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 2px 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.NoteNode-color-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.NoteNode-color-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.NoteNode-color-option {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.2s ease;
}

.NoteNode-color-option:hover {
  transform: scale(1.15);
  border-color: rgba(0, 0, 0, 0.3);
}

.NoteNode-textarea {
  width: 100%;
  min-height: 120px;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.6;
  color: #333;
  background-color: rgba(255, 255, 255, 0.5);
  resize: vertical;
  font-family: inherit;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.NoteNode-textarea:focus {
  outline: none;
  border-color: rgba(0, 0, 0, 0.2);
  background-color: rgba(255, 255, 255, 0.8);
}

.NoteNode-textarea:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.NoteNode-textarea::placeholder {
  color: rgba(0, 0, 0, 0.3);
  font-style: italic;
}

/* 复制按钮样式 */
.NoteNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.NoteNode-container:hover .NoteNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.NoteNode-duplicate-button:hover {
  background: rgba(255, 255, 255, 1);
  border-color: #3b82f6;
  color: #3b82f6;
  transform: scale(1.05);
}

.NoteNode-duplicate-button:active {
  transform: scale(0.95);
}

.react-flow__node.selected .NoteNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/NoteNode.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,qCAAqC;EACrC;;cAEY;EACZ,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,gBAAgB;EAChB,oBAAoB;EACpB,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/**\n * 便签节点样式\n */\n\n.NoteNode-container {\n  position: relative;\n  min-width: 280px;\n  max-width: 400px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  transition: box-shadow 0.2s ease;\n}\n\n.NoteNode-container:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.NoteNode-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);\n}\n\n.NoteNode-icon {\n  font-size: 16px;\n}\n\n.NoteNode-title {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.NoteNode-color-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 2px 4px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.NoteNode-color-btn:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.NoteNode-color-picker {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 10px;\n  padding: 8px;\n  background-color: rgba(255, 255, 255, 0.8);\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.NoteNode-color-option {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.NoteNode-color-option:hover {\n  transform: scale(1.15);\n  border-color: rgba(0, 0, 0, 0.3);\n}\n\n.NoteNode-textarea {\n  width: 100%;\n  min-height: 120px;\n  padding: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #333;\n  background-color: rgba(255, 255, 255, 0.5);\n  resize: vertical;\n  font-family: inherit;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.NoteNode-textarea:focus {\n  outline: none;\n  border-color: rgba(0, 0, 0, 0.2);\n  background-color: rgba(255, 255, 255, 0.8);\n}\n\n.NoteNode-textarea:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.NoteNode-textarea::placeholder {\n  color: rgba(0, 0, 0, 0.3);\n  font-style: italic;\n}\n\n/* 复制按钮样式 */\n.NoteNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.95);\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.NoteNode-container:hover .NoteNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.NoteNode-duplicate-button:hover {\n  background: rgba(255, 255, 255, 1);\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: scale(1.05);\n}\n\n.NoteNode-duplicate-button:active {\n  transform: scale(0.95);\n}\n\n.react-flow__node.selected .NoteNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
